import { baseUrlImage } from 'config';

export const getImageUrl = (src: string | null | undefined) =>
  src ? baseUrlImage + src : undefined;
